module.exports = __webpack_public_path__ + "img/note-up.9844b215.png";